import { FC, useState } from 'react'
import {
  BooleanInput, SelectInput, TextInput, required, useTranslate,
  useRecordContext, useGetList,
} from 'react-admin'
import { useWatch } from 'react-hook-form'
import { Box, Button, Collapse, Typography } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { McpServerOut, ApplicationEnvironmentOut } from '../../types/apiRequests'

const AdvancedSettings: FC = () => {
  const translate = useTranslate()
  const [open, setOpen] = useState(false)
  const record = useRecordContext<McpServerOut>()
  const autoApprove = useWatch<{ auto_approve: boolean }>({ name: 'auto_approve' })
  const applicationId = record?.application_id

  const { data: environments } = useGetList<ApplicationEnvironmentOut>(
    'application_environment',
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'name', order: 'ASC' },
      // eslint-disable-next-line camelcase
      filter: { application_id: applicationId },
    },
    { enabled: !!applicationId }
  )

  const envChoices = (environments ?? []).map(e => ({ id: e.id, name: e.display_name }))

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Button
        onClick={() => setOpen(!open)}
        startIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{ textTransform: 'none', color: 'text.secondary', fontWeight: 600 }}
      >
        {translate('data.advancedSettings')}
      </Button>
      <Collapse in={open}>
        <Box sx={{ mt: 1, pl: 1 }}>
          <BooleanInput source="auto_approve" label="data.autoApproveAccess" />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mt: -1, mb: 2, pl: 5 }}
          >
            {translate('data.isDemoHelp')}
          </Typography>
          <TextInput
            source="default_base_url"
            label="data.defaultBaseUrl"
            fullWidth
            validate={autoApprove ? required() : undefined}
            helperText={translate('data.defaultBaseUrlHelp')}
          />
          {envChoices.length > 0 && (
            <SelectInput
              source="default_environment_id"
              label="data.defaultEnvironment"
              choices={envChoices}
              fullWidth
              validate={autoApprove ? required() : undefined}
              helperText={translate('data.defaultEnvironmentHelp')}
              emptyText="ra.action.clear_input_value"
            />
          )}
        </Box>
      </Collapse>
    </Box>
  )
}

export default AdvancedSettings
